/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum UserRole {
  Admin = "Admin",
  Client = "Client",
  Employee = "Employee",
}

export interface AddFavoriteInput {
  productId: number;
}

export interface CreateCategoryInput {
  name: string;
}

export interface CreateProductInput {
  name: string;
  url: string;
  imgUrl: string;
  reference: string;
  lastQuantity: number;
  lastPrice: number;
}

export interface CreateReferenceInput {
  name: string;
  url: string;
  imgUrl: string;
  reference: string;
  lastQuantity: number;
  lastPrice: number;
  userId: number;
}

export interface CreateRoundInput {
  hour: number;
  siteId: number;
  sentinelId: number;
}

export interface CreateScanInput {
  quantity: number;
  quantityVariation: number;
  restocking: number;
  sales: number;
  price: number;
  ca: number;
}

export interface CreateSentinelInput {
  name: string;
  ip: string;
}

export interface CreateUserInput {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface CreateUserSiteInput {
  userId: number;
  siteId: number;
}

export interface FavoriteProductsFiltersInput {
  userId?: number | null;
  productId?: number | null;
}

export interface LoginAsInput {
  email: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface ProductsFiltersInput {
  search?: string | null;
  priceOnly?: boolean | null;
  siteId?: number | null;
  ids?: number[] | null;
  productIds?: number[] | null;
  start?: string | null;
  end?: string | null;
  orderByPrice?: string | null;
  orderByQuantity?: string | null;
  orderByCreatedAt?: string | null;
}

export interface ReferencesFiltersInput {
  search?: string | null;
  userId?: number | null;
  start?: string | null;
  end?: string | null;
  orderByPrice?: string | null;
  orderByQuantity?: string | null;
  orderByCreatedAt?: string | null;
}

export interface RoundsFiltersInput {
  sentinelId?: number | null;
  siteId?: number | null;
}

export interface ScansFiltersInput {
  search?: string | null;
  productId?: number | null;
  productIds?: number[] | null;
  siteId?: number | null;
  orderByCa?: string | null;
  orderByPrice?: string | null;
  orderByPriceVariation?: string | null;
  orderByQuantity?: string | null;
  orderByQuantityVariation?: string | null;
  orderByCreatedAt?: string | null;
  start?: string | null;
  end?: string | null;
}

export interface SentinelsFiltersInput {
  search?: string | null;
  start?: string | null;
  end?: string | null;
}

export interface SitesFiltersInput {
  search?: string | null;
  categoryId?: number | null;
}

export interface UpdateCategoryInput {
  name?: string | null;
}

export interface UpdateProductInput {
  name?: string | null;
  url?: string | null;
  imgUrl?: string | null;
  reference?: string | null;
  lastQuantity?: number | null;
  lastPrice?: number | null;
}

export interface UpdateReferenceInput {
  name?: string | null;
  url?: string | null;
  imgUrl?: string | null;
  reference?: string | null;
  lastQuantity?: number | null;
  lastPrice?: number | null;
  userId?: number | null;
}

export interface UpdateRoundInput {
  hour?: number | null;
  siteId?: number | null;
  sentinelId?: number | null;
}

export interface UpdateScanInput {
  quantity?: number | null;
  quantityVariation?: number | null;
  restocking?: number | null;
  sales?: number | null;
  price?: number | null;
  ca?: number | null;
}

export interface UpdateSentinelInput {
  name?: string | null;
  ip?: string | null;
}

export interface UpdateSiteInput {
  name?: string | null;
  url?: string | null;
  categoryId?: number | null;
}

export interface UpdateUserInput {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  password?: string | null;
  role?: UserRole | null;
}

export interface UserSitesFiltersInput {
  userId?: number | null;
  siteId?: number | null;
}

export interface UsersFiltersInput {
  search?: string | null;
  role?: UserRole | null;
  roles?: UserRole[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
